
export const IVORY_COAST_CITIES = [

    "Abidjan",

    "Yamoussoukro",

    "Bouaké",

    "San-Pédro",

    "Korhogo",

    "Daloa",

    "Man",

    "Gagnoa",

    "Abengourou",

    "Bondoukou",

    "Divo",

    "Odienné",

    "Soubré",

    "Séguéla",

    "Ferkessédougou",

    "Agboville",

    "Anyama",

    "Grand-Bassam",

    "Bingerville",

    "Aboisso",

];

export const IVORY_COAST_TOWNS = [

    "Abobo",

    "Adjamé",

    "Attécoubé",

    "Cocody",

    "Koumassi",

    "Marcory",

    "Plateau",

    "Port-Bouët",

    "Treichville",

    "Yopougon",

    "Anyama",

    "Bingerville",

    "Songon",

    "Séguéla",

    "Ferkessédougou",

    "Agboville",

    "Grand-Bassam",

    "Gagnoa",

    "Moossou",

];